import { obtemDDD, obtemNumero } from '@/views/util/util';

export class ContatoDTO {
  nome: string;
  dddTelefone: string;
  numeroTelefone: string;

  constructor(
    nome: string,
    dddTelefone: string,
    numeroTelefone: string
  ) {
    this.nome = nome;
    this.dddTelefone = dddTelefone;
    this.numeroTelefone = numeroTelefone;
  }

  public static construir(
    nome: string,
    telefoneCompleto: string
  ): ContatoDTO {
    if (telefoneCompleto.indexOf(")") > -1) {
      const ddd = obtemDDD(telefoneCompleto);
      const numero = obtemNumero(telefoneCompleto);
      return new ContatoDTO(nome, ddd, numero);
    } else {
      return new ContatoDTO(nome, "", telefoneCompleto);
    }
  }
}
